import { ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../../../util';

export function getSelectionStyles() {
  return {
    'td[data-focused="false"], th[data-focused="false"]': {
      '*:focus-visible, &:focus, &:focus-visible': {
        outline: 'none',
      },

      '*:focus': {
        ...focusOutline,
      },
    },
    '[data-focused="true"]:not(.row__separator__cell)': {
      '&:not([data-editionmode="true"])': {
        '&:focus, & > *:focus, *:focus-visible': {
          ...focusOutline,

          '&.cell__download__document': {
            outlineOffset: 0,
          },
        },
      },
      '&[data-editionmode="true"]': {
        '&:focus, *:focus, *:focus-visible': {
          ...focusOutline,
          outlineStyle: 'dotted',
          outlineWidth: '6px',
          outlineOffset: '-4px',
        },
      },
    },
    '[data-focused="true"].row__separator__cell': {
      backgroundColor: 'palette.secondary.main',
      outline: 'none',
    },
  } as ThemeUICSSObject;
}
